import { render, staticRenderFns } from "./ProgramLevelDoubleSelectbox.vue?vue&type=template&id=0a011640"
import script from "./ProgramLevelDoubleSelectbox.vue?vue&type=script&lang=js"
export * from "./ProgramLevelDoubleSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports